// Define a function for select customization
function customizeSelect($select) {
    var $this = $select,
        $styledSelect = $('<div class="select-styled"></div>'),
        $list = $('<ul class="select-options"></ul>');

    let $listSelectContainer = $this.closest('.listselect-container')
    if ($listSelectContainer.hasClass('enable-select2')) {
        return;
    }

    $this.addClass('select-hidden').wrap('<div class="select"></div>').after($styledSelect);

    // Populate the dropdown options
    $this.children('option').each(function () {
        var $option = $(this);
        var $listItem = $('<li></li>').text($option.text()).attr('rel', $option.val());

        if ($option.is(':selected')) {
            $listItem.addClass('is-selected');
        }

        $listItem.appendTo($list);
    });

    $list.insertAfter($styledSelect);

    $styledSelect.text($this.children('option').eq(0).text());

    // Handle click events
    $styledSelect.click(function (e) {
        e.stopPropagation();
        $('div.select-styled.active').not(this).removeClass('active').next('ul.select-options').hide();
        $(this).toggleClass('active').next('ul.select-options').toggle();
    });

    $list.on('click', 'li', function (e) {
        e.stopPropagation();
        var $listItem = $(this);
        $styledSelect.text($listItem.text()).removeClass('active');
        $this.val($listItem.attr('rel'));
        $list.find('li.is-selected').removeClass('is-selected');
        $listItem.addClass('is-selected');
        $list.hide();
    });
}

$(document).on('nfFormReady', function (event, response) {
    $('select').each(function () {
        customizeSelect($(this));
    });
});